import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const OrangeButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-orange-button">
      {children}
    </IfmsButton>
  );
});

OrangeButton.defaultProps = {
};

OrangeButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large']),
};

export default React.memo(OrangeButton);

